<template>
    <Head title="Reset Password" />

    <div class="w-100 h-[calc(100vh-64px)] bg-gray-100">
        <div class="m-auto max-w-sm pt-24">
            <div class="rounded border border-gray-50 bg-white p-4">
                <div class="text-[28px] font-bold tracking-tight">
                    Reset Password
                </div>

                <form @submit.prevent="submit">
                    <div class="my-4 text-gray-800">
                        Please enter a new password for your EMTprep.com account
                    </div>

                    <div class="mb-4">
                        <FormInput
                            label="Email"
                            id="email"
                            type="email"
                            label-classes="block text-base"
                            css-classes="rounded border-gray-50 bg-gray-50 focus:border-primary-300 focus:border w-full shadow  pr-8"
                            v-model="form.email"
                        />
                    </div>

                    <div class="mb-4">
                        <FormInput
                            label="Password"
                            id="password"
                            type="password"
                            label-classes="block text-base"
                            css-classes="rounded border-gray-50 bg-gray-50 focus:border-primary-300 focus:border w-full shadow  pr-8"
                            v-model="form.password"
                            :autofocus="true"
                        />
                    </div>

                    <div class="mb-4">
                        <FormInput
                            label="Confirm Password"
                            id="password_confirmation"
                            type="password"
                            label-classes="block text-base"
                            css-classes="rounded border-gray-50 bg-gray-50 focus:border-primary-300 focus:border w-full shadow  pr-8"
                            v-model="form.password_confirmation"
                        />
                    </div>

                    <FormErrors class="my-4" />

                    <div class="mt-8 flex flex-col items-center">
                        <Button
                            class="btn btn-primary w-full"
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="form.processing"
                            @button-click="submit()"
                        >
                            Reset Password
                        </Button>
                    </div>
                </form>
            </div>
            <div class="my-4 w-full text-center text-gray-700">
                Still having issues?
                <Link class="link" :href="route('frontend.contact-us')">
                    Contact Us
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import FrontendFullscreen from "@/_Layouts/FrontendFullscreen";
import Button from "@/Components/Button.vue";
import FormCheckbox from "@/Components/FormCheckbox.vue";
import FormInput from "@/Components/FormInput.vue";
import FormErrors from "@/Components/FormErrors.vue";

export default {
    name: "ForgotPassword",
    layout: FrontendFullscreen,
    components: {
        Button,
        FormCheckbox,
        FormInput,
        FormErrors,
    },
    data() {
        return {
            form: this.$inertia.form({
                token: this.$page.props.token,
                email: this.$page.props.email,
                password: "",
                password_confirmation: "",
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(route("password.update"), {
                onFinish: () =>
                    this.form.reset("password", "password_confirmation"),
            });
        },
    },
};
</script>

<style scoped></style>
